module.exports = __webpack_public_path__ + "img/icon263.dc584107.png";